<template>
  <b-modal :active.sync="isModalActive" scroll="keep" :canCancel="true" :onCancel="onClose">
    <div class="chart-wrapper">
      <b-tabs>
        <b-tab-item label="予測と実績の比較">
          <div class="chart-container">
            <canvas ref="predActual" width="836" height="400"></canvas>
          </div>

        </b-tab-item>
        <b-tab-item label="CAP">
          <div class="chart-container">
            <canvas ref="cap" width="836" height="400"></canvas>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>

  </b-modal>
</template>

<script>
import Chart from '../../node_modules/chart.js/src/chart'

import getPredActualData from '../modules/chart/predictActual'
import getCAPData from '../modules/chart/cap'

export default {
  name: 'ChartModal',
  data () {
    return {
      chart: {}
    }
  },
  props: {
    predActualData: {},
    capData: {},
    isModalActive: false
  },
  updated () {

    if (!this.isModalActive) return

    const chartDataSet = [
      {key: 'predActual', data: getPredActualData(this.predActualData)},
      {key: 'cap', data: getCAPData(this.capData)}
    ]

    for (let i in chartDataSet) {
      let dataSet = chartDataSet[i]
      let key = dataSet.key

      if (this.chart[key]) {
        this.chart[key].destroy()
        this.chart[key] = null
      }

      const canvas = this.$refs[key].getContext('2d')

      this.chart[key] = new Chart(canvas, dataSet.data)
    }

  },
  methods: {
    onClose () {
      this.$parent.chart.isModalActive = false
    }
  }
}
</script>

<style scoped>
  .chart-wrapper {
    background: white;
    height: auto;
  }

  .chart-container {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/ChartModal.vue